import ProfilePayment from './profile-payment.vue'
export default ProfilePayment